import * as yup from "yup";
export const validationSchema = yup.object().shape({
  KidAgree: yup.boolean().oneOf([true], "Требуется согласие"),
  PolicyholderAgreement: yup.boolean().oneOf([true], "Требуется согласие"),
  PolicyAgree: yup.boolean().oneOf([true], "Требуется согласие"),
  InsuranceRulesAgree: yup.boolean().oneOf([true], "Требуется согласие"),
  AcceptanceAgree: yup.boolean().oneOf([true], "Требуется согласие"),
});
